















import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Model } from "vue-property-decorator";

export interface ISelectBox {
  key: string;
  innerValue: string;
  diaplayValue: string;
}

@Component
export default class SelectBox extends Vue {
  name: "SelectBox";

  @Model("selected-item", { type: String, default: null })
  selectedItem: string | null;

  @Prop({ required: true })
  public id!: string;

  @Prop({ default: [] })
  public list!: [];

  @Prop({ default: false })
  public isShowEmptyOption!: boolean;

  get selectedValue() {
    return this.selectedItem;
  }
  set selectedValue(value) {
    this.$emit("selected-item", value);
  }
}
